 
 
 
 


define([
    'display/map',
    './addressModel',
    './poiModel',
    './addressRangesModel',
    './entryPointModel',
    'model/objectModel',
    '../../services/utils'
], function(
    L,
    AddressModel,
    PoiModel,
    AddressRangesModel,
    EntryPointModel,
    ObjectModel,
    utils
) {
    'use strict';
    var SIMPLE_PROPERTIES = ['dist', 'score', 'type', 'entityType'];
    var SearchModel;

    /**
     * For future readers: these functions were added to satisfy tics cyclomatic complexity score
     */

    function addSimpleProperties(json) {
        SIMPLE_PROPERTIES.forEach(function(property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);
    }

    function addAddress(json) {
        if (typeof json.address !== 'undefined') {
            this.address = new AddressModel(json.address);
        }
    }

    function addPosition(json) {
        if (typeof json.position !== 'undefined') {
            this.position = utils.convertToLatLng(json.position);
        }
    }

    function addPoi(json) {
        if (typeof json.poi !== 'undefined') {
            this.poi = new PoiModel(json.poi);
        }
    }

    function addAdressRanges(json) {
        if (typeof json.addressRanges !== 'undefined') {
            this.addressRanges = new AddressRangesModel(json.addressRanges);
        }
    }

    function setBoundingBox(json) {
        if (typeof json.boundingBox !== 'undefined') {
            this.boundingBox = L.latLngBounds(
                utils.convertToLatLng(json.boundingBox.btmRightPoint),
                utils.convertToLatLng(json.boundingBox.topLeftPoint)
            );
        }
    }

    function setViewport(json) {
        if (typeof json.viewport !== 'undefined') {
            this.viewport = L.latLngBounds(
                utils.convertToLatLng(json.viewport.btmRightPoint),
                utils.convertToLatLng(json.viewport.topLeftPoint)
            );
        }
    }

    function addEntryPoints(json) {
        if (typeof json.entryPoints !== 'undefined') {
            this.entryPoints = json.entryPoints.map(function(entry) {
                return new EntryPointModel(entry);
            });
        }
    }

    SearchModel = function(json) {
        addSimpleProperties.call(this, json);
        addAddress.call(this, json);
        addPosition.call(this, json);
        addPoi.call(this, json);
        addAdressRanges.call(this, json);
        setBoundingBox.call(this, json);
        setViewport.call(this, json);
        addEntryPoints.call(this, json);
        return this;
    };
    SearchModel.prototype = Object.create(ObjectModel.prototype);
    SearchModel.prototype.constructor = SearchModel;

    SearchModel.prototype.simplify = function() {
        var result = {}, key;
        var simplifier = function(item) {
            return item.simplify();
        };

        for (key in this) {
            if (this.hasOwnProperty(key)) {
                if (this[key] instanceof Array && this[key].length > 0 && this[key][0].simplify) {
                    result[key] = this[key].map(simplifier);
                } else if (typeof this[key] === 'object' && this[key].simplify) {
                    result[key] = this[key].simplify();
                } else if (this[key] instanceof L.LatLng) {
                    result[key] = {lat: this[key].lat, lon: this[key].lng};
                } else if (this[key] instanceof L.LatLngBounds) {
                    result[key] = {
                        topLeftPoint: {lat: this[key].getSouthWest().lat, lon: this[key].getSouthWest().lng},
                        btmRightPoint: {lat: this[key].getNorthEast().lat, lon: this[key].getNorthEast().lng}
                    };
                } else {
                    result[key] = this[key];
                }
            }
        }
        return result;
    };

    return SearchModel;

});



// WEBPACK FOOTER //
// ./model/search/searchModel.js